import { render } from "./Enrollments.vue?vue&type=template&id=6d53f1ea"
import script from "./Enrollments.vue?vue&type=script&lang=js"
export * from "./Enrollments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__